import { isSalesViewEnabled } from '@ab-core-functions/sales-view';
import {
    userCanSeeBestPrice,
    userCanSeeBestPriceOnProductCard,
    userHasOnlySalesView as userHasOnlySalesViewFunction
} from '@ab-core-functions/user-permission';
import { formatPrice } from '@ab-core/functions';
import type { BestPrice as BestPriceGraphType } from '@ab-core/graphql/dist';
import { useAuth } from '@ab-core/hooks';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import { FallbackContainer } from './styled';

type BestPriceProps = Pick<BestPriceGraphType, 'value'> & { hideBestPriceOnSalesView: boolean };

export const BestPriceComponent: FC<BestPriceProps> = (props) => {
    const { value, hideBestPriceOnSalesView = false } = props;
    const { user } = useAuth();
    const isSalesView = isSalesViewEnabled(user?.activeAccount?.accountNumber);
    const userHasOnlySalesView = userHasOnlySalesViewFunction();

    const hasBestPrice = userCanSeeBestPrice();
    const hasBestPriceOnProductCard = userCanSeeBestPriceOnProductCard();

    if (
        !hasBestPrice ||
        !hasBestPriceOnProductCard ||
        hideBestPriceOnSalesView ||
        isSalesView ||
        userHasOnlySalesView
    ) {
        return <FallbackContainer />;
    }

    return (
        <div className="flex-justify-content-space-between">
            <Text>Bestpreis</Text>
            <Text color={value ? 'primary' : 'black'}>{value ? formatPrice(value) : '-'}</Text>
        </div>
    );
};
